<!--
 * @Descripttion:
 * @Author: zcy
 * @Date: 2022-01-07 10:16:16
 * @LastEditors: lishiqiao
 * @LastEditTime: 2023-09-13 10:53:17
-->
<template>
  <div class="page-list">
    <!-- 实时存塘量 -->
    <div class="page-search-content" ref="searchBox">
      <div class="page-big-box">
        <div class="page-search-item">
          <label>日期&nbsp;:</label>
          <el-date-picker :picker-options="pickerOptions" key="date" value-format="yyyy-MM" v-model="param.costMonth"
            type="month" placeholder="请选择月份">
          </el-date-picker>
        </div>
        <div class="page-search-item">
          <label>公司&nbsp;:</label>
          <el-select v-model="param.orgId" placeholder="请选择公司">
            <el-option label="全部公司" value=""></el-option>
            <el-option :key="item.id" v-for="item in GongSiList" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </div>
        <div class="page-search-item">
          <label>造次&nbsp;:</label>
          <el-select v-model="param.periodId" placeholder="请选择造次">
            <el-option label="全部造次" value=""></el-option>
            <el-option :key="item.id" v-for="item in PiCiList" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </div>
        <div class="page-search-item">
          <label>品类&nbsp;:</label>
          <el-select v-model="param.breedTypeId" placeholder="请选择品类">
            <el-option label="全部品类" value=""></el-option>
            <el-option :key="item.id" v-for="item in PinLeiList" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </div>
        <div class="page-search-item">
          <label>品种&nbsp;:</label>
          <el-select v-model="param.breedId" placeholder="请选择品种">
            <el-option label="全部品种" value=""></el-option>
            <el-option :key="item.id" v-for="item in PinZhongList" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </div>
      </div>
      <div class="page-search-btn">
        <div class="search-btn" @click="pageSearch">查询</div>
        <div class="reset-btn" @click="reSet">重置</div>
        <div class="search-close-btn">
          <div @click="PageSearchClose" v-if="PageDisplay">
            <span>收起</span><i class="iconfont icon-a-List-Expand"></i>
          </div>
          <div @click="PageSearchOn" v-else>
            <span>展开</span><i class="iconfont icon-List-Collapse"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="page-list-content">
      <div class="page-list-title">
        <div><i class="title-icon"></i>养成月存塘成本统计表</div>
        <div>单位：{{ tableTitle }}</div>
        <div>日期：{{ tableDate }}</div>
        <div>
          <el-dropdown style="margin-right: 30px;" @command="setFixedColumn">
            <span class="el-dropdown-link">
              冻结列<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="y">冻结至"{{
                fixedColumn.label
              }}"列</el-dropdown-item>
              <el-dropdown-item command="n">取消冻结</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <span @click="doExport">
            <i class="title-export-btn iconfont icon-a-List-Export"></i>导出报表
          </span>
        </div>
      </div>
      <el-table :data="tableData" :max-height="tableHeight" border style="width: 100%" :row-class-name="tableRowClassName"
        @header-click="handleClick">
        <el-table-column :fixed="fixedColumnList[0].fixed" :class-name="fixedColumnList[0].selected ? 'cellSelected' : ''"
          prop="orgName" label="单位名称"> </el-table-column>
        <el-table-column :fixed="fixedColumnList[1].fixed" :class-name="fixedColumnList[1].selected ? 'cellSelected' : ''"
          prop="periodName" label="养殖造次"> </el-table-column>
        <el-table-column :fixed="fixedColumnList[2].fixed" :class-name="fixedColumnList[2].selected ? 'cellSelected' : ''"
          prop="breedTypeName" label="养殖品类"></el-table-column>
        <el-table-column :fixed="fixedColumnList[3].fixed" :class-name="fixedColumnList[3].selected ? 'cellSelected' : ''"
          prop="breedName" label="养殖品种"></el-table-column>
        <el-table-column label="变动成本">
          <el-table-column label="种苗">
            <el-table-column prop="putNumberSeed" label="数量"></el-table-column>
            <el-table-column prop="putMoneySeed" label="金额"></el-table-column>
          </el-table-column>
          <el-table-column label="饲料">
            <el-table-column prop="putNumberFodd" :label="'数量(' + fodderKgToJin + ')'"></el-table-column>
            <el-table-column prop="putMoneyFodd" label="金额"></el-table-column>
          </el-table-column>
          <el-table-column prop="putMoneyDrug" label="动保"></el-table-column>
          <el-table-column prop="costElectricCost" label="电费"></el-table-column>
          <el-table-column prop="costArtificialCost" label="人工"></el-table-column>
          <el-table-column prop="costConsumableCost" label="低值易耗品"></el-table-column>
          <el-table-column prop="costNetCost" label="拉网费"></el-table-column>
          <el-table-column prop="costDeprecitCost" label="折旧与摊销"></el-table-column>
          <el-table-column prop="repairCost" label="修理费"></el-table-column>
          <el-table-column prop="fuelFee" label="燃料费"></el-table-column>
          <el-table-column prop="rentalFee" label="租凭费"></el-table-column>
          <el-table-column prop="costPublic" label="其他公摊"></el-table-column>
        </el-table-column>
        <el-table-column label="定额费用">
          <el-table-column prop="costOldCost" label="网箱折旧"></el-table-column>
          <el-table-column prop="costManageCost" label="网箱管理费"></el-table-column>
          <el-table-column prop="costSeaAreaCost" label="海域费"></el-table-column>
          <el-table-column prop="costRentPondCost" label="塘租"></el-table-column>
        </el-table-column>
        <el-table-column prop="costTotal" label="成本合计"></el-table-column>
        <el-table-column label="存塘信息">
          <el-table-column prop="seedlingDays" label="养殖天数"></el-table-column>
          <el-table-column prop="avgSpec" label="存塘规格"></el-table-column>
          <el-table-column prop="storageFishNum" label="存塘数量"></el-table-column>
          <el-table-column prop="storageWeight" label="存塘重量"></el-table-column>
          <el-table-column prop="unitCostTotal" label="单位成本"></el-table-column>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import Page from "@/utils/methods/page";
import {
  monthInitPageList,
  getAllJiGouMonth,
  getAllPiCiMonth,
  getAllPinLeiMonth,
  getAllPinZhongMonth,
} from "./yc-overage-services";
import { listParamStatus } from "@/api/general.js";
export default {
  data() {
    return {
      pickerOptions: {
        // 超出当前年份或月份不可选
        disabledDate: (time) => {
          return time.getTime() > Date.now();
        },
      },
      tableTitle: "",
      tableDate: "",
      selectDate: Page.getCurrentMonth(), //选择到显示在列表左上方的日期
      date: Page.getCurrentMonth(),
      value: "",
      PageDisplay: true,
      tableData: [],
      tableHeight: 0, // 表格高度
      fixedColumn: {},
      fixedColumnList: [
        {
          prop: "orgName",
          fixed: false,
          selected: false
        },
        {
          prop: "periodName",
          fixed: false,
          selected: false
        },
        {
          prop: "breedTypeName",
          fixed: false,
          selected: false
        },
        {
          prop: "breedName",
          fixed: false,
          selected: false
        },
      ],
      param: {
        rootId: localStorage.getItem("rootId"), //一级公司
        orgId: "", //子公司
        seedlingDataId: "", //批次ID
        periodId: "", //造次ID
        breedTypeId: "", //品种ID
        breedId: "", //一级公司
        costMonth: Page.getCurrentMonth(), //月份
        breedTypeClass: "fish",
      },
      GongSiList: [],
      PiCiList: [],
      PinLeiList: [],
      PinZhongList: [],
      fodderKgToJin: '公斤'   // 是否把公斤转换成斤
    };
  },
  watch: {},
  created() {
    this.tableHeight = window.innerHeight - 400;
  },
  mounted() {
    this.getAllSearchSelect();
    this.initPage(this.param);
    Page.pagesTableFixed();
    // 获取是否公斤转换成斤
    listParamStatus(this.param.params.rootOrgId, ['fodderKgToJin']).then((res) => {
      if (res.code == "0000") {
        this.fodderKgToJin = res.data.fodderKgToJin === true ? '斤' : '公斤';
      }
    })
  },
  methods: {
    getAllSearchSelect() {
      let rootId = localStorage.getItem("rootId");
      Promise.all([
        getAllJiGouMonth(rootId),
        getAllPiCiMonth(rootId),
        getAllPinLeiMonth(rootId),
        getAllPinZhongMonth(rootId),
      ])
        .then((result) => {
          const [JiGouData, PiCiData, PinLeiData, PinZhongData] = result;
          this.GongSiList = JiGouData.data;
          this.PiCiList = PiCiData.data;
          this.PinLeiList = PinLeiData.data;
          this.PinZhongList = PinZhongData.data;
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    doExport() {
      this.$confirm(`导出表格为excel文件，请确认！`, "操作提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
      })
        .then(async () => {
          const param = {
            title: "育苗/养成月存塘成本统计表",
            rootId: this.param.rootId,
            orgId: this.param.orgId,
            seedlingDataId: this.param.seedlingDataId,
            periodId: this.param.periodId,
            breedTypeId: this.param.breedTypeId,
            breedId: this.param.breedId,
            breedTypeClass: "fish",
            costMonth: this.param.costMonth,
            fileName: "养成-存塘概览报表(月存塘成本)",
          };
          const flag = await Page.exportDatas(
            "/midCostTotalOrg/exportMdtPondHarvestList",
            param
          );
        })
        .catch(() => { });
    },
    // 表格行高亮
    tableRowClassName({ row, rowIndex }) {
      if (row.orgName === "合计") {
        return "heji-row";
      }
    },
    initPage(data) {
      const loading = this.$loading({
        lock: true,
        text: "数据加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      monthInitPageList(data)
        .then((res) => {
          this.tableTitle = Page.orgIdFilter(data.orgId, this.GongSiList);
          this.tableDate = Page.costMonthFilter(data.costMonth);
          this.tableData = res.data.list;
          setTimeout(() => {
            loading.close();
          }, 0);
        })
        .catch((err) => {
          this.$message.error(err);
          setTimeout(() => {
            loading.close();
          }, 0);
        });
    },
    reSet() {
      this.param = {
        rootId: localStorage.getItem("rootId"), //一级公司
        orgId: "", //子公司
        seedlingDataId: "", //批次ID
        periodId: "", //造次ID
        breedTypeId: "", //品种ID
        breedId: "", //一级公司
        costMonth: Page.getCurrentMonth(), //月份
        breedTypeClass: "fish",
      };
      this.initPage(this.param);
    },
    // 查询按钮
    pageSearch() {
      this.initPage(this.param);
    },
    PageSearchClose() {
      Page.PageSearchClose(this);
    },
    PageSearchOn() {
      Page.PageSearchOn(this);
    },

    // 选中列
    handleClick(column, event) {
      this.fixedColumnList.forEach((item, i) => {
        if (JSON.stringify(this.fixedColumnList).includes(column.property)) {
          if (item.prop === column.property) {
            item.selected = !item.selected;
            if (item.selected) {
              this.fixedColumn = column;
              this.fixedColumn.idx = i;
            } else {
              this.fixedColumn = {};
            }
          } else {
            item.selected = false;
          }
        }
      });
    },

    // 设置冻结列
    setFixedColumn(command) {
      if (command === 'y') {
        if (JSON.stringify(this.fixedColumn) === "{}") {
          this.$message('请选择列');
          return;
        }
        this.fixedColumnList.forEach(item => {
          item.fixed = false;
          item.selected = false;
        })
        this.fixedColumnList.forEach((item, i) => {
          if (i <= this.fixedColumn.idx) {
            item.fixed = true;
          }
        })
        this.$message('已冻结至"' + this.fixedColumn.label + '"列');
        this.fixedColumn = {};
      } else if (command === 'n') {
        this.fixedColumnList.forEach(item => {
          item.fixed = false;
          item.selected = false;
        })
        this.$message('已取消冻结');
      }
    }
  },
};
</script>

<style lang="less" scoped></style>



